<template>
  <el-dialog
    top="10vh"
    :title="form.id ? $t('Common.edit') : $t('Common.create')"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="showModel"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('Fota.firmwareModel')" prop="firmwareModelId">
        <Select
          :disabled="form.id.length > 0"
          :query="$api.fota.firmware_page"
          v-model="form.firmwareModelId"
          :placeholder="$t('Common.tipsSelect1')"
          :labelOptions="{
            key: 'id',
            value: 'name'
          }"
          @getRaw="handleFirmwareModelId"
        />
      </el-form-item>
      <el-form-item :label="$t('Fota.firmwareVersion')" prop="version">
        <el-input v-model.trim="form.version" :placeholder="$t('Fota.tips4')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('Fota.versionAlias')">
        <el-input
          v-model.trim="form.versionAlias"
          :placeholder="$t('Common.maxLengthTips16')"
          :maxlength="16"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Fota.firmwareUpload')" :required="!form.id">
        <el-upload
          ref="upload"
          action=""
          :multiple="false"
          :auto-upload="false"
          :limit="1"
          :on-change="upload"
          :on-exceed="explainFile"
          :on-remove="delFile"
          accept=".bin"
          :file-list="fileList"
        >
          <el-button size="small">{{ $t('Fota.selectFile') }}</el-button>
        </el-upload>
      </el-form-item>
      <!--      v-if="selectSingleType === 'DOUBLE'"-->
      <el-form-item
        :label="`${$t('Fota.firmwareUpload')} 2`"
        :required="!form.id"
        v-if="selectSingleType === 'DOUBLE'"
      >
        <el-upload
          ref="upload2"
          action=""
          :multiple="false"
          :auto-upload="false"
          :limit="1"
          :on-change="upload2"
          :on-exceed="explainFile2"
          :on-remove="delFile2"
          accept=".bin"
          :file-list="fileList2"
        >
          <el-button size="small">{{ $t('Fota.selectFile') }}</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item :label="$t('Fota.remark')" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          maxlength="100"
          show-word-limit
          v-model.trim="form.remark"
          resize="none"
          :placeholder="$t('Fota.remark')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">{{ $t('Common.cancel') }}</el-button>
      <el-button type="primary" size="small" @click="save" :loading="loading">{{
        $t('Common.save')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Select from '@/components/CommonForm/Select'

export default {
  props: {
    showModel: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    Select
  },
  data() {
    return {
      firmwareType: 'DTU',
      form: {
        id: '',
        firmwareModelId: '',
        version: '',
        versionAlias: '',
        file: '',
        remark: '',
        file2: ''
      },
      rules: {
        firmwareModelId: [
          {
            required: true,
            message: this.$t('Fota.firmwareModel'),
            trigger: ['blur', 'change']
          }
        ],
        version: [
          {
            required: true,
            message: this.$t('Fota.firmwareVersion'),
            trigger: 'blur'
          }
        ]
      },
      fileList: [],
      fileList2: [],
      loading: false,
      selectSingleType: ''
    }
  },
  mounted() {
    if (this.row.id) {
      this.form = {
        ...this.row
      }
      this.selectSingleType = this.row.modelType
      if (this.row.modelType === 'DOUBLE') {
        if (this.row.file2Id) {
          this.fileList2 = [
            {
              name: this.row.file2Name,
              url: this.row.file2Url,
              id: this.row.file2Id
            }
          ]
        } else {
          this.fileList2 = []
        }
      }
      this.fileList = [
        {
          name: this.row.fileName,
          url: this.row.fileUrl,
          id: this.row.fileId
        }
      ]
    }
  },
  methods: {
    handleFirmwareModelId(firm) {
      this.selectSingleType = firm.type
    },
    explainFile() {
      this.$message({
        message: `${this.$t('Fota.tips5')}`,
        type: 'warning'
      })
    },
    upload(file) {
      this.form.file = file.raw
    },
    delFile() {
      this.form.file = ''
    },
    explainFile2() {
      this.$message({
        message: `${this.$t('Fota.tips5')}`,
        type: 'warning'
      })
    },
    upload2(file) {
      this.form.file2 = file.raw
    },
    delFile2() {
      this.form.file2 = ''
    },
    close() {
      this.$emit('update:showModel', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      if (!this.form.file && !this.form.id) {
        this.$message.error(`${this.$t('Fota.tips6')}`)
        return false
      }
      if (this.selectSingleType === 'DOUBLE' && !this.form.file2 && !this.form.id) {
        this.$message.error(`${this.$t('Fota.tips6')}`)
        return false
      }
      this.loading = true

      let params = new FormData()
      params.append('id', this.form.id)
      params.append('firmwareModelId', this.form.firmwareModelId)
      params.append('version', this.form.version)
      params.append('versionAlias', this.form.versionAlias)
      params.append('file', this.form.file)
      params.append('file2', this.form.file2 || null)
      params.append('remark', this.form.remark)
      params.append('firmwareType', this.firmwareType)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let api = this.form.id
        ? this.$api.fota.firmware_version_update
        : this.$api.fota.firmware_version_insert
      this.$ajax
        .post(api, params, config)
        .then(() => {
          this.$message.success(
            `${this.form.id ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`
          )
          this.close()
          this.$emit('refresh')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.textarea-div {
  width: 342px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  /deep/ .el-textarea {
    textarea {
      border: none;
    }
  }
  .textarea-more {
    margin: 0 15px;
    padding: 8px 0;
    border-top: 1px solid #dcdcdc;
    .file-type {
      font-size: 12px;
      color: #999999;
    }
    .total {
      float: right;
      line-height: 38px;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
